<div
  class="relative flex h-full flex-col justify-between overflow-hidden rounded-lg bg-white shadow-S"
  [class.opacity-50]="!asset.is_usable"
>
  <div>
    @if (asset.image) {
      <img
        [src]="asset.image"
        alt="img"
        class="h-24 max-h-24 w-full rounded-t-lg object-cover"
      />
    }
  </div>
  <div class="flex h-full flex-col justify-start px-3 py-2 pb-3 text-sm">
    <p class="font-accent font-normal text-neutral-800">{{ asset.name }}</p>
    <div class="text-sm font-bold">
      {{ assetTagText(asset) | translate }}
    </div>
    <p class="line-clamp-3 pt-1 font-base text-xs font-normal text-neutral-600">
      {{ asset.description }}
    </p>
    @if (!asset.is_usable) {
      <p class="mt-2 font-bold">
        {{
          'como.asset-available-in-points'
            | translate: { points: (asset.points_remaining ?? 0) / 100 }
        }}
      </p>
    }
  </div>
  @if (asset.is_usable && displayAddButton) {
    <div class="mb-4 flex flex-col items-center justify-center">
      @if (isAssetInCart) {
        <div
          class="mb-2 flex flex-row items-center justify-center text-sm font-normal leading-snug lg:text-base"
        >
          <i class="icon icon-check-circle mr-2 text-success-600"></i>
          {{ 'como.asset-added-to-cart' | translate }}
        </div>
      }
      @if (!isAssetInCart) {
        <app-button-atom
          [label]="'como.use-voucher' | translate"
          (click)="onAssetAdd(asset)"
          icon="icon-plus"
          size="XS"
          thickSize="XS"
          type="outlined"
          color="neutral"
        ></app-button-atom>
      }
      @if (isAssetInCart) {
        <app-button-atom
          [label]="'como.remove-voucher' | translate"
          (click)="onAssetRemove(asset)"
          icon="icon-c-remove"
          size="XS"
          thickSize="XS"
          type="outlined"
          color="neutral"
        ></app-button-atom>
      }
    </div>
  }
</div>
